import React, { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { api } from '../api/client'
import AuthCard, { authCardStyles as s } from './AuthCard'
import Button from './Button'
import Input from './Input'
import { ROUTES } from '../routes'
import {
  MIN_PASSWORD_LENGTH,
  OTHER_SESSIONS_NOTICE,
  PASSWORD_RESET_DONE,
  PASSWORD_TOO_SHORT,
  PASSWORDS_DO_NOT_MATCH,
  translateAuthError
} from '../authMessages'

// Страница по ссылке из письма. Одноразовый токен из ссылки обменивается на
// короткоживущий reset-токен, дальше работает тот же путь смены пароля, что и у
// подтверждения по токену Финтабло — второго механизма записи пароля нет.
export default function ResetPasswordPage ({ onLogin }) {
  const [params] = useSearchParams()
  const token = params.get('token')

  const [stage, setStage] = useState('redeeming') // redeeming | password | done | invalid
  const [resetToken, setResetToken] = useState(null)
  const [password, setPassword] = useState('')
  const [repeat, setRepeat] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [user, setUser] = useState(null)

  useEffect(() => {
    // Обмен идёт сразу при открытии: пользователь пришёл по ссылке и не должен
    // делать лишний шаг, чтобы узнать, что ссылка уже недействительна.
    if (!token) {
      setError(translateAuthError({ code: 'RESET_TOKEN_INVALID' }))
      setStage('invalid')
      return
    }
    let cancelled = false
    api.redeemPasswordReset(token)
      .then(data => {
        if (cancelled) return
        setResetToken(data.reset_token)
        setStage('password')
      })
      .catch(err => {
        if (cancelled) return
        setError(translateAuthError(err))
        setStage('invalid')
      })
    return () => { cancelled = true }
  }, [token])

  async function handleSubmit (e) {
    e.preventDefault()
    if (loading) return

    if (password.length < MIN_PASSWORD_LENGTH) {
      setError(PASSWORD_TOO_SHORT)
      return
    }
    if (password !== repeat) {
      setError(PASSWORDS_DO_NOT_MATCH)
      return
    }

    setError(null)
    setLoading(true)
    try {
      const result = await api.confirmPasswordReset(resetToken, password)
      localStorage.setItem('ch_token', result.token)
      setUser(result.user)
      setStage('done')
    } catch (err) {
      setError(translateAuthError(err))
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthCard>
      {stage === 'redeeming' && <div style={s.hint}>Проверяем ссылку…</div>}

      {stage === 'invalid' && (
        <div style={s.form}>
          <div style={s.error} role='alert'>{error}</div>
          <Link style={s.link} to={ROUTES.LOGIN}>Запросить новую ссылку</Link>
        </div>
      )}

      {stage === 'done' && (
        <div style={s.form}>
          <div style={s.stepTitle}>{PASSWORD_RESET_DONE}</div>
          <div style={s.hint}>{OTHER_SESSIONS_NOTICE}</div>
          <Button
            variant='solid'
            onClick={() => onLogin(user)}
            style={{ width: '100%', marginTop: 4 }}
          >
            Продолжить
          </Button>
        </div>
      )}

      {stage === 'password' && (
        <form onSubmit={handleSubmit} style={s.form}>
          <div style={s.stepTitle}>Задайте новый пароль</div>

          <div style={s.field}>
            <label style={s.label} htmlFor='reset-new-password'>Новый пароль</label>
            <Input
              aria-label='Новый пароль'
              autoComplete='new-password'
              autoFocus
              id='reset-new-password'
              onChange={e => setPassword(e.target.value)}
              placeholder='Минимум 8 символов'
              required
              type='password'
              value={password}
            />
          </div>

          <div style={s.field}>
            <label style={s.label} htmlFor='reset-repeat-password'>Повторите пароль</label>
            <Input
              aria-label='Повторите пароль'
              autoComplete='new-password'
              id='reset-repeat-password'
              onChange={e => setRepeat(e.target.value)}
              placeholder='Ещё раз новый пароль'
              required
              type='password'
              value={repeat}
            />
          </div>

          {error && <div style={s.error} role='alert'>{error}</div>}

          <Button
            type='submit'
            variant='solid'
            loading={loading}
            style={{ width: '100%', marginTop: 4 }}
          >
            Сохранить пароль
          </Button>
        </form>
      )}
    </AuthCard>
  )
}
